import { getEditor, isEnabled } from '../composables/editorsMap';
import { getCleanClass, typographyOptions } from '../composables/utils';
import SelectOptions from '../menuItemComponents/SelectOptions.vue';
import { Ref } from 'vue';
export const gettextTypeOptions = (id: string, typographyRef: Ref) => {
  const editor = getEditor(id)?.value;

  return {
    disabled: !isEnabled(id, 'text_type'),
    title: 'סוג טקסט',
    text: typographyRef,
    type: 'select',
    showArrow: true,
    component: SelectOptions,
    props: {
      alignmentCenter: false,
      options: typographyOptions,
      action: option => {
        const { $from } = editor?.state?.selection ?? null;
        const node = $from.node();
        editor
          .chain()
          .focus()
          [option.actionMethod]({
            ...option.attributes,
            class: getCleanClass(node, option),
          })
          .setFontSize(option.attributes.fontSize)
          .run();
        typographyRef.value = option.text;
      },
      isActive: option => {
        const { $from } = editor?.state?.selection ?? null;
        const node = $from.node();
        const type =
          option.actionMethod == 'setHeading' ? 'heading' : 'paragraph';
        return editor?.isActive(type, {
          class: getCleanClass(node, option),
        });
      },
    },
  };
};
